export default {
	c1: 1,
	c2: 2,
	c3: 4,
	c4: 8,
	c5: 16,
	c6: 32,
	c7: 64,
	c8: 128,
	t1: 256,
	t2: 512,
	t3: 1024,
	t4: 2048,
	t5: 4096,
	t6: 8192,
	t7: 16384,
	t8: 32768,
	t9: 65536,
	t10: 131072,
	t11: 262144,
	t12: 524288,
	l1: 1048576,
	l2: 2097152,
	l3: 4194304,
	l4: 8388608,
	l5: 16777216,
	s1: 33554432,
	s2: 67108864,
	s3: 134217728,
	s4: 268435456,
	s5: 536870912,
} as const;
